import React, { useEffect } from "react";
import cl from "./Policy.module.css";
import { animateScroll as scroll } from "react-scroll";

const Policy = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_policy}>
      <h1>Política de Privacidad</h1>
      <p>Última actualización: 07 de febrero de 2024 </p>
      <p>
        Esta Política de Privacidad describe nuestras políticas y procedimientos
        con respecto a la recopilación, el uso y la divulgación de tu
        información cuando utilizas el Servicio, y te informa sobre tus derechos
        de privacidad y cómo la ley te protege.
      </p>
      <p>
        Utilizamos tus datos personales para proporcionar y mejorar el Servicio.
        Al utilizar el Servicio, aceptas la recopilación y el uso de la
        información de acuerdo con esta Política de Privacidad. Esta Política de
        Privacidad ha sido creada con la ayuda del Generador de Política de
        Privacidad.
      </p>
      <h2>Interpretación y definiciones </h2>
      <b>Interpretación </b>
      <p>
        Las palabras en mayúscula tienen significados definidos en las
        siguientes condiciones. Las siguientes definiciones tendrán el mismo
        significado independientemente de si aparecen en singular o en plural.
      </p>
      <b>Definiciones </b>
      <p>Para los fines de esta Política de Privacidad: </p>
      <ul style={{ marginLeft: "30px" }}>
        <li>
          <p>
            <strong>Cuenta</strong> significa una cuenta única creada para ti
            para acceder a nuestro Servicio o partes de nuestro Servicio.
          </p>
        </li>
        <li>
          <p>
            <strong>Afiliado</strong> significa una entidad que controla, es
            controlada o está bajo control común con una parte, donde "control"
            significa propiedad del 50% o más de las acciones, intereses
            patrimoniales u otros valores con derecho a voto para la elección de
            directores u otra autoridad de gestión.
          </p>
        </li>
        <li>
          <p>
            <strong>Empresa</strong> (también referida como "la Compañía",
            "Nosotros", "Nuestro" o "Nuestra" en este Acuerdo) se refiere a{" "}
            {props.shopName}.
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies</strong> son pequeños archivos que se colocan en tu
            computadora, dispositivo móvil o cualquier otro dispositivo desde un
            sitio web, que contienen detalles de tu historial de navegación en
            ese sitio web entre sus múltiples usos.
          </p>
        </li>
        <li>
          <p>
            <strong>País</strong> se refiere a: Arkansas, Estados Unidos
          </p>
        </li>
        <li>
          <p>
            <strong>Dispositivo</strong> significa cualquier dispositivo que
            pueda acceder al Servicio, como una computadora, un teléfono móvil o
            una tableta digital.
          </p>
        </li>
        <li>
          <p>
            <strong>Datos personales</strong> se refiere a cualquier información
            relacionada con una persona identificada o identificable.
          </p>
        </li>
        <li>
          <p>
            <strong>Servicio</strong> se refiere al Sitio Web.
          </p>
        </li>
        <li>
          <p>
            <strong>Proveedor de servicios</strong> significa cualquier persona
            física o jurídica que procesa datos en nombre de la Compañía. Se
            refiere a empresas o personas terceras empleadas por la Compañía
            para facilitar el Servicio, para proporcionar el Servicio en nombre
            de la Compañía, para realizar servicios relacionados con el Servicio
            o para asistir a la Compañía en el análisis de cómo se utiliza el
            Servicio.
          </p>
        </li>
        <li>
          <p>
            <strong>Datos de uso</strong> se refiere a los datos recopilados
            automáticamente, generados por el uso del Servicio o por la propia
            infraestructura del Servicio (por ejemplo, la duración de una visita
            a la página).
          </p>
        </li>
        <li>
          <p>
            <strong>Sitio Web</strong> se refiere a {props.shopName}, accesible
            desde {props.domain}
          </p>
        </li>
        <li>
          <p>
            <strong>Tú</strong> significa el individuo que accede o utiliza el
            Servicio, o la empresa u otra entidad legal en nombre de la cual
            dicho individuo accede o utiliza el Servicio, según corresponda.
          </p>
        </li>
      </ul>
      <h2>Recopilación y Uso de Tus Datos Personales</h2>
      <h3 style={{ marginBottom: "20px" }}>Tipos de Datos Recopilados</h3>
      <h4>Datos Personales</h4>
      <p>
        Mientras utilizas Nuestro Servicio, es posible que te solicitemos que
        nos proporciones cierta información de identificación personal que se
        puede utilizar para contactarte o identificarte. La información de
        identificación personal puede incluir, pero no se limita a:
      </p>
      <ul style={{ marginBottom: "30px", marginLeft: "30px" }}>
        <li>Datos de Uso</li>
      </ul>
      <h4>Datos de Uso</h4>
      <p>
        Los Datos de Uso se recopilan automáticamente durante el uso del
        Servicio.
      </p>
      <p>
        Los Datos de Uso pueden incluir información como la dirección IP de tu
        dispositivo (por ejemplo, dirección IP), tipo de navegador, versión del
        navegador, las páginas de nuestro Servicio que visitas, la hora y fecha
        de tu visita, el tiempo que pasas en esas páginas, identificadores
        únicos del dispositivo y otros datos de diagnóstico.
      </p>
      <p>
        Cuando accedes al Servicio a través de un dispositivo móvil, es posible
        que recopilemos automáticamente cierta información, incluido, entre
        otros, el tipo de dispositivo móvil que utilizas, tu ID único de
        dispositivo móvil, la dirección IP de tu dispositivo móvil, tu sistema
        operativo móvil, el tipo de navegador de Internet móvil que utilizas,
        identificadores únicos del dispositivo y otros datos de diagnóstico.
      </p>
      <h3>Uso de tus datos personales</h3>
      <p>
        La Compañía puede utilizar los Datos Personales para los siguientes
        propósitos:
      </p>
      <ul style={{ marginLeft: "30px" }}>
        <li>
          <p>
            <strong>Para proporcionar y mantener nuestro Servicio</strong>,
            incluido el monitoreo del uso de nuestro Servicio.
          </p>
        </li>
        <li>
          <p>
            <strong>Para administrar tu cuenta:</strong> para administrar tu
            registro como usuario del Servicio. Los Datos Personales que
            proporcionas pueden darte acceso a diversas funciones del Servicio
            disponibles para ti como usuario registrado.
          </p>
        </li>
        <li>
          <p>
            <strong>Para la ejecución de un contrato:</strong> el desarrollo,
            cumplimiento y asunción del contrato de compra de los productos,
            artículos o servicios que hayas adquirido o de cualquier otro
            contrato con nosotros a través del Servicio.
          </p>
        </li>
        <li>
          <p>
            <strong>Para contactarte:</strong> Para contactarte por correo
            electrónico, llamadas telefónicas, SMS u otras formas equivalentes
            de comunicación electrónica, como notificaciones push de una
            aplicación móvil sobre actualizaciones o comunicaciones informativas
            relacionadas con las características, productos o servicios
            contratados, incluidas actualizaciones de seguridad, cuando sea
            necesario o razonable para su implementación.
          </p>
        </li>
        <li>
          <p>
            <strong>Para proporcionarte</strong> noticias, ofertas especiales e
            información general sobre otros bienes, servicios y eventos que
            ofrecemos y que son similares a los que ya has adquirido o sobre los
            que has solicitado información, a menos que hayas optado por no
            recibir dicha información.
          </p>
        </li>
        <li>
          <p>
            <strong>Para gestionar tus solicitudes:</strong> Para gestionar tus
            solicitudes hacia nosotros.
          </p>
        </li>
        <li>
          <p>
            <strong>Para transferencias comerciales:</strong> Podemos utilizar
            tu información para evaluar o llevar a cabo una fusión, cesión,
            reestructuración, reorganización, disolución u otra venta o
            transferencia de parte o la totalidad de nuestros activos, ya sea
            como empresa en funcionamiento o como parte de una quiebra,
            liquidación u otro procedimiento similar, en el que los Datos
            Personales que tenemos sobre los usuarios del Servicio sean uno de
            los activos transferidos.
          </p>
        </li>
        <li>
          <p>
            <strong>Para otros fines:</strong> Podemos utilizar tu información
            para otros fines, como análisis de datos, identificación de
            tendencias de uso, determinación de la efectividad de nuestras
            campañas promocionales y para evaluar y mejorar nuestro Servicio,
            productos, servicios, marketing y tu experiencia.
          </p>
        </li>
      </ul>
      <p>
        Podemos compartir tu información personal en las siguientes situaciones:
      </p>
      <ul style={{ marginBottom: "30px", marginLeft: "30px" }}>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con Proveedores de Servicios:</strong> Podemos compartir tu
          información personal con Proveedores de Servicios para monitorear y
          analizar el uso de nuestro Servicio, y para contactarte.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Para Transferencias Comerciales:</strong> Podemos compartir o
          transferir tu información personal en relación con, o durante
          negociaciones de, cualquier fusión, venta de activos de la Compañía,
          financiamiento o adquisición de toda o parte de nuestro negocio a otra
          empresa.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con Afiliados:</strong> Podemos compartir tu información con
          nuestros afiliados, en cuyo caso les exigiremos que respeten esta
          Política de Privacidad. Los afiliados pueden incluir nuestra empresa
          matriz y cualquier otra subsidiaria, empresa conjunta o empresa bajo
          nuestro control común.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con Socios Comerciales:</strong> Podemos compartir tu
          información con nuestros socios comerciales para ofrecerte ciertos
          productos, servicios o promociones.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con Otros Usuarios:</strong> cuando compartes información
          personal o interactúas en áreas públicas con otros usuarios, esa
          información puede ser vista por todos los usuarios y puede ser
          distribuida públicamente fuera de ellas.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong>Con Tu Consentimiento</strong>: podemos divulgar tu
          información personal para cualquier otro propósito con tu
          consentimiento.
        </li>
      </ul>
      <h3>Conservación de tus datos personales</h3>
      <p>
        La Compañía conservará tus Datos Personales solo durante el tiempo
        necesario para los fines establecidos en esta Política de Privacidad.
        Conservaremos y utilizaremos tus Datos Personales en la medida en que
        sea necesario para cumplir con nuestras obligaciones legales (por
        ejemplo, si estamos obligados a conservar tus datos para cumplir con las
        leyes aplicables), resolver disputas y aplicar nuestros acuerdos legales
        y políticas.
      </p>
      <p>
        La Compañía también conservará los Datos de Uso para fines de análisis
        interno. Los Datos de Uso generalmente se conservan por un período de
        tiempo más corto, excepto cuando estos datos se utilizan para mejorar la
        seguridad o la funcionalidad de nuestro Servicio, o estamos legalmente
        obligados a conservar estos datos por períodos de tiempo más largos.
      </p>
      <h3>Transferencia de tus datos personales</h3>
      <p>
        Tu información, incluidos los Datos Personales, se procesa en las
        oficinas de la Compañía y en cualquier otro lugar donde se encuentren
        las partes involucradas en el procesamiento. Esto significa que esta
        información puede ser transferida a — y mantenida en — computadoras
        ubicadas fuera de tu estado, provincia, país u otra jurisdicción
        gubernamental donde las leyes de protección de datos pueden ser
        diferentes a las de tu jurisdicción.
      </p>
      <p>
        Tu consentimiento a esta Política de Privacidad seguido de tu envío de
        dicha información representa tu acuerdo a dicha transferencia.
      </p>
      <p>
        La Compañía tomará todas las medidas razonablemente necesarias para
        garantizar que tus datos sean tratados de forma segura y de acuerdo con
        esta Política de Privacidad y que no se realice ninguna transferencia de
        tus Datos Personales a una organización o país a menos que existan
        controles adecuados, incluida la seguridad de tus datos y otra
        información personal.
      </p>
      <h3>Cancellación de tus datos personales</h3>
      <p>
        Tienes el derecho de eliminar o solicitar nuestra asistencia para
        eliminar los Datos Personales que hemos recopilado sobre ti.
      </p>
      <p>
        Nuestro Servicio puede brindarte la oportunidad de eliminar cierta
        información sobre ti dentro del Servicio.
      </p>
      <p>
        Puedes actualizar, modificar o eliminar tu información en cualquier
        momento accediendo a tu Cuenta, si tienes una, y visitando la sección de
        configuración de la cuenta que te permite administrar tu información
        personal. También puedes contactarnos para solicitar acceso, corrección
        o eliminación de cualquier información personal que nos hayas
        proporcionado.
      </p>
      <p>
        Sin embargo, ten en cuenta que es posible que debamos conservar cierta
        información cuando tengamos una obligación legal o una base legal para
        hacerlo.
      </p>
      <h3 style={{ marginBottom: "10px" }}>
        Divulgación de tus datos personales
      </h3>
      <h4>Transacciones comerciales</h4>
      <p>
        Si la Compañía está involucrada en una fusión, adquisición o venta de
        activos, tus Datos Personales pueden ser transferidos. Proporcionaremos
        un aviso antes de que tus Datos Personales sean transferidos y estén
        sujetos a una Política de Privacidad diferente.
      </p>
      <h4>Aplicación de la ley</h4>
      <p>
        En ciertas circunstancias, la Compañía puede estar obligada a divulgar
        tus Datos Personales si así lo requiere la ley o en respuesta a
        solicitudes válidas de autoridades públicas (por ejemplo, un tribunal o
        una agencia gubernamental).
      </p>
      <h4>Otros requisitos legales</h4>
      <p>
        La Compañía puede divulgar tus Datos Personales de buena fe cuando
        consideremos que dicha acción es necesaria para:
      </p>
      <ul style={{ marginBottom: "30px", marginLeft: "30px" }}>
        <li>Cumplir con una obligación legal</li>
        <li>Proteger y defender los derechos o la propiedad de la Compañía</li>
        <li>
          Prevenir o investigar posibles infracciones relacionadas con el
          Servicio
        </li>
        <li>
          Proteger la seguridad personal de los usuarios del Servicio o del
          público
        </li>
        <li>Protegerse contra la responsabilidad legal</li>
      </ul>
      <h3>Seguridad de tus Datos Personales</h3>
      <p>
        La seguridad de tus Datos Personales es importante para nosotros, pero
        recuerda que ningún método de transmisión por Internet o almacenamiento
        electrónico es 100% seguro. Aunque hacemos todo lo posible por utilizar
        medios comercialmente aceptables para proteger tus Datos Personales, no
        podemos garantizar su seguridad absoluta.
      </p>
      <h2>Privacidad de Menores</h2>
      <p>
        Nuestro Servicio no está dirigido a personas menores de 13 años. No
        recopilamos conscientemente información de identificación personal de
        personas menores de 13 años. Si eres padre, tutor o responsable y sabes
        que tu hijo nos ha proporcionado Datos Personales, contáctanos. Si nos
        damos cuenta de que hemos recopilado Datos Personales de personas
        menores de 13 años sin verificación del consentimiento paterno,
        tomaremos medidas para eliminar esa información de nuestros servidores.
      </p>
      <p>
        Si debemos confiar en el consentimiento como base legal para el
        tratamiento de tu información y tu país requiere el consentimiento de un
        padre, es posible que solicitemos el consentimiento de tus padres antes
        de recopilar y usar dicha información.
      </p>
      <h2>Enlaces a Otros Sitios Web</h2>
      <p>
        Nuestro Servicio puede contener enlaces a otros sitios web que no son
        operados por nosotros. Si haces clic en un enlace de un tercero, serás
        dirigido al sitio de ese tercero. Te recomendamos encarecidamente que
        revises la Política de Privacidad de cada sitio que visites.
      </p>
      <p>
        No tenemos control y no asumimos responsabilidad alguna por el
        contenido, las políticas de privacidad o las prácticas de ningún sitio o
        servicio de terceros.
      </p>
      <h2>Modificaciones a esta Política de Privacidad</h2>
      <p>
        Podemos actualizar nuestra Política de Privacidad de vez en cuando. Te
        informaremos de cualquier cambio publicando la nueva Política de
        Privacidad en esta página.
      </p>
      <p>
        Te informaremos por correo electrónico y/o con un aviso destacado en
        nuestro Servicio antes de que el cambio entre en vigencia y
        actualizaremos la "Fecha de Última Actualización" en la parte superior
        de esta Política de Privacidad.
      </p>
      <p>
        Te recomendamos que revises esta Política de Privacidad periódicamente
        para ver si hay cambios. Los cambios a esta Política de Privacidad
        entran en vigencia cuando se publican en esta página.
      </p>
      <h2>Contáctanos</h2>
      <p>
        Si tienes preguntas sobre esta Política de Privacidad, puedes
        contactarnos:
      </p>
      <ul style={{ marginLeft: "30px" }}>
        <li>Por correo electrónico: supporto@{props.domain}</li>
      </ul>
    </section>
  );
};

export default Policy;
